import React, { useEffect } from "react";
import "./Invoice80mm.css";
import { dynamicImage } from "../../../../Service";
import api from "../../../../utils/api";
import { useParams } from "react-router-dom";

const BookingInvoice = () => {
    const [invoiceData, setInvoiceData] = React.useState<any>(null);
    const params = useParams();
    const ticketBookingId = params.id || "0";
    const fetchInvoiceData = async () => {
        try {
            const response = await api.get(`/api/TicketBooking/GetTicketBookingByBookingId?bookingId=${ticketBookingId}`);
            setInvoiceData(response.data);
        } catch (error) {
            console.error("Error fetching invoice data:");
        }
    };

    useEffect(() => {
        fetchInvoiceData();
        if (invoiceData) {
            window.print();
        } else {
            setTimeout(window.print, 1000);
        }
    }, []);
    const handlePrint = () => {
        window.print();
    };

    return (
        <div className='page-body'>
            <div className="invoice-container">
                <button className="print-button" onClick={handlePrint}>🖨️ Print</button>
                <div className="invoice">
                    <div className="logo">
                        <img src={dynamicImage("logo/logo.png")} alt="Logo" />
                        <h2>SHIVALYA WATER PARK</h2>
                    </div>

                    <div className="details">
                        <p><strong>Ticket No.:</strong> {invoiceData?.ticketUniqueId}</p>
                        <p><strong>Customer Name:</strong> {invoiceData?.customerName}</p>
                        <p><strong>Mobile Number:</strong> {invoiceData?.customerMobileNumber}</p>
                        <p><strong>Booking Date:</strong> {invoiceData?.bookingDate}</p>
                    </div>
                    { invoiceData?.offerName &&
                    <div className="details">
                        <p><strong>Offer Name:</strong> {invoiceData?.offerName}</p>
                        <p><strong>Free For:</strong> {invoiceData?.freeType}</p>
                        <p><strong>Total Free:</strong> {invoiceData?.totalFree}</p>
                    </div>
                    }
                    <div className="details">
                        <p><strong>No. of Adults:</strong> {invoiceData?.numberOdAdults}</p>
                        <p><strong>No. of Children:</strong> {invoiceData?.numberOfChildren}</p>
                    </div>
                    { invoiceData?.discountPer &&
                    <div className="details">
                        <p><strong>Discount Amount:</strong> {invoiceData?.discountAmt}</p>
                    </div>
                    }
                    <div className="totals">
                        <p><strong>Total Amount :</strong> Rs {invoiceData?.payAmount}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingInvoice;
